module.exports = __webpack_public_path__ + "img/hipercard.1b0dadef.svg";